import {useEffect, useRef} from "react";

interface AudioPlayerProps {
    source: string
}

export default function AudioPlayer(props: AudioPlayerProps) {
    const audioRef = useRef<HTMLAudioElement>()

    useEffect(() => {
        audioRef.current.pause()
        audioRef.current.load()
        audioRef.current.play()
    }, [props.source])

    return <audio controls ref={audioRef}>
        <source src={props.source} type="audio/mpeg"/>
    </audio>
}